import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { COUNTRIES, useCurrency } from './CurrencyContext';
import { CountryCode, getCountryConfig } from './countries';
export function CountrySelector() {
  const {
    country,
    setCountry
  } = useCurrency();
  const config = getCountryConfig(country);
  return <div className="fixed right-2 top-1.5 z-[60] sm:right-3 sm:top-2" data-id="element-92" data-mp="1petpxxmq2kbc">
      <label className="relative flex items-center gap-1 rounded-full border border-[#2f5842] bg-[#0f2b1d]/90 py-1 pl-2 pr-1.5 text-[10px] font-bold uppercase tracking-[0.08em] text-[#e7f0e8] shadow-sm backdrop-blur-sm sm:text-xs" data-id="element-93" data-mp="2d57kbuss4v93">
        <GlobeIcon aria-hidden="true" className="h-3.5 w-3.5 text-[#c5dfbb]" data-id="element-94" data-mp="237t33sz182fq" />
        <span className="sr-only" data-id="element-95" data-mp="285unqic3w9tb">País y moneda</span>
        <span aria-hidden="true" data-id="element-96" data-mp="2849seqhywmue">
          {config.code} · {config.currency}
        </span>
        <select value={country} onChange={event => setCountry(event.target.value as CountryCode)} aria-label="Selecciona tu país y moneda" className="absolute inset-0 h-full w-full cursor-pointer appearance-none bg-transparent text-transparent opacity-0 focus:outline-none" data-id="element-97" data-mp="rqbanpmwip8i">
          {COUNTRIES.map(item => <option key={item.code} value={item.code} data-id="element-98" data-mp="3a98vl1u23etj">
              {item.name} ({item.currency})
            </option>)}
        </select>
      </label>
    </div>;
}